import { Controller } from '@hotwired/stimulus'

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR
const REFRESH_INTERVAL = 30 * SECOND

export default class extends Controller {
  static values = {
    deadline: String,
    start: String,
    format: String,
    secondsFormat: String,
    day1: Object,
    day2: Object,
  }

  static targets = ['counter', 'rate', 'label']

  initialize() {
    this.timer = null
  }

  connect() {
    this.#refresh()
  }

  disconnect() {
    this.#stop()
  }

  #refresh() {
    const countdown = this.hasDeadlineValue
    const distance = countdown
      ? new Date(this.deadlineValue) - Date.now()
      : Date.now() - new Date(this.startValue)

    if (countdown && distance <= 0) {
      this.#stop()
      const { day1Value: day1, day2Value: day2 } = this
      this.rateTarget.textContent = day2.rate
      this.labelTarget.textContent = day2.label
      this.counterTarget.textContent = day2.value
      this.#swap(this.element, day1.tone, day2.tone)
      this.#swap(this.labelTarget, day1.label_classes, day2.label_classes)
      this.#swap(this.counterTarget, day1.value_classes, day2.value_classes)

      return
    }

    this.counterTarget.textContent = this.#formatted(distance)
    this.timer = setTimeout(() => this.#refresh(), this.#nextDelay(distance))
  }

  #swap(element, from, to) {
    if (!from || !to) return

    element.classList.remove(...from.split(' '))
    element.classList.add(...to.split(' '))
  }

  #formatted(distance) {
    if (this.#final(distance)) {
      return this.secondsFormatValue.replace('%{seconds}', Math.ceil(distance / SECOND))
    }

    return this.formatValue
      .replace('%{days}', Math.floor(distance / DAY))
      .replace('%{hours}', Math.floor((distance % DAY) / HOUR))
      .replace('%{minutes}', String(Math.floor((distance % HOUR) / MINUTE)).padStart(2, '0'))
  }

  #nextDelay(distance) {
    return this.#final(distance) ? SECOND : REFRESH_INTERVAL
  }

  #final(distance) {
    return this.hasDeadlineValue && this.hasSecondsFormatValue && distance < MINUTE
  }

  #stop() {
    clearTimeout(this.timer)
    this.timer = null
  }
}
